// extracted by mini-css-extract-plugin
module.exports = {"header":"FormHeader_header__2JVYp","header__right":"FormHeader_header__right__sCkYK","step__title":"FormHeader_step__title__fH1g8"};